<template>
  <div class="mt-1.5 flex flex-wrap items-center gap-1" v-if="reactionEntries.length">
    <HoverableTooltip
      v-for="entry in reactionEntries"
      :key="entry.emoji"
      contentClass="p-2!"
    >
      <button
        class="flex h-6 cursor-pointer items-center gap-1 rounded-chip border-0 px-2
               text-body leading-none select-none transition-colors duration-100"
        :class="entry.mine ? 'bg-accent-soft text-accent' : 'bg-input text-text hover:bg-hover'"
        @click.stop="toggle(entry.emoji)"
      >
        <span>{{ entry.emoji }}</span>
        <span class="min-w-2 font-medium">{{ entry.count }}</span>
      </button>
      <template #tooltip>
        <div class="flex max-w-55 flex-col gap-1.5">
          <div
            class="flex items-center gap-2"
            v-for="reactor in entry.reactors"
            :key="reactor.id"
          >
            <UserAvatar withDayoffBadge :user="reactor" />
            <span class="truncate text-body text-text">{{ reactor.username }}</span>
          </div>
          <div class="text-center text-group" v-if="!entry.reactors.length">{{ entry.emoji }}</div>
        </div>
      </template>
    </HoverableTooltip>

    <ReactionAddButton :comment="comment" :taskId="taskId" v-slot="{ toggle: openPicker }">
      <button
        class="flex h-6 cursor-pointer items-center rounded-chip border-0 bg-transparent px-1
               text-text-muted transition-colors duration-100 hover:text-accent"
        @click.stop="openPicker"
      >
        <IconAddReactionOutlineRounded class="size-4" />
      </button>
    </ReactionAddButton>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { IconAddReactionOutlineRounded } from '@iconify-prerendered/vue-material-symbols';
import UserAvatar from '@/components/elements/UserAvatar';
import HoverableTooltip from '@/components/elements/HoverableTooltip';
import ReactionAddButton from '@/components/elements/ReactionAddButton';

const props = defineProps({
  comment: Object,
  taskId: String,
});

const store = useStore();

const myId = computed(() => store.state.user.user?.id);

const parse = (value) => {
  if (!value) return {};
  return typeof value === 'string' ? JSON.parse(value) : value;
};

const reactionEntries = computed(() => {
  const counts = parse(props.comment.userReactions);
  const whoReacted = parse(props.comment.whoReacted);
  return Object.keys(counts).map((emoji) => {
    const userIds = whoReacted[emoji] || [];
    return {
      emoji,
      count: counts[emoji],
      mine: userIds.includes(myId.value),
      reactors: userIds.map(id => store.getters['user/getUser'](id)).filter(u => u && u.id),
    };
  });
});

const toggle = (emoji) => {
  store.dispatch('project/actionReactToComment', {
    commentId: props.comment.id,
    taskId: props.taskId,
    emoji,
  });
};
</script>
